<template>
<div class="center">
  <div class="container">
    <div :class="{list:true,lister:listshow}">
      <span class="title">
        {{center.CENTER_TITLE}}
      </span>
      <div class="text">
        {{center.CONTER_TEXT}}
      </div>
      <!-- <div class="corner">
      </div> -->
    </div>
      <div class="container-item">
        <div v-for="(art, idx) in imgs" :key="idx" :class="{itemo:true,itemoer:itemoershow}" rel="nofollow">
          <a class="" target="_blank" href="">
            <div
              class="itemo-color">
              <img style="" :src="art.img" />
              <!-- <div class="one">SEO</div> -->
            </div>
                <!-- <div style="width:100%;height:auto;text-align:center;margin-top:-45px;">
                  <img style="height:90px;width:90px;" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/hankong/05.png" />
                </div> -->
                <div
                  class="two">
                <p>
                  {{art.title}}
                </p>
                <!-- <div class="button">了解详情</div> -->
                </div>
          </a>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      itemoershow: false,
      listshow: false,
      center: [],
      imgs: [],
      twocons: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.center = response.data.CENTER
        this.imgs = response.data.CENTER.CONTER_CON
        // this.twocons = response.data.CENTER.CONTER_TWO
        // console.log(this.center)
      })
  },
  methods: {
    handleScroll () {
      // console.log(this.currentScroll)
      // this.currentScroll = window.innerHeight
      this.currentScroll = window.pageYOffset
      // console.log(this.innerHeight)
      // console.log(window.pageYOffset, this.currentScroll)
      if (this.currentScroll >= 1000) {
        // console.log(this.currentScroll)
        this.itemoershow = true
      }
      if (this.currentScroll >= 800) {
        this.listshow = true
      }
    }
  }
  // },
  // methods: {
  //   more: function (event) {
  //     window.location.href = '#/scope'
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import url('../../static/less/less.css');
//>1100
// @keyframes FadeUp{
//   from {bottom: -30px;}
//   to {bottom: 0px;}
// }
// @keyframes FadeDown {
//   from {top: -40px;}
//   to {top: 0px;}
// }
@media only screen and (min-width: 1024px) {
  .itemo {
    width: 22%;
    height: 260px;
    float: left;
    margin: 10px;
  }
  // .itemo-color {
  //   img {
  //     width: 60%;
  //     padding: 22% 2% 8% 2%;
  //   }
  // }
}
@media only screen and (min-width: 1024px) and (max-width: 960px) {
  .itemo {
    width: 22%;
    height: 260px;
    float: left;
    margin: 10px;
  }
  // .itemo-color {
  //   img {
  //     width: 60%;
  //     padding: 12% 2% 8% 2%;
  //   }
  // }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .itemo {
    width: 45%;
    height: 260px;
    float: left;
    margin: 10px;
  }
  // .itemo-color {
  //   img {
  //     width: 60%;
  //     padding: 12% 2% 8% 2%;
  //   }
  // }
}
@media only screen and (min-width: 479px) and (max-width: 767px) {
  .itemo {
    width: 250px;
    height: 260px;
    float: left;
    margin: 10px;
  }
  // .itemo-color {
  //   img {
  //     width: 60%;
  //     padding: 12% 2% 8% 2%;
  //   }
  // }
}
@media only screen and (max-width: 479px) {
  .itemo {
    width: 43%;
    height: 280px;
    float: left;
    margin: 10px;
  }
  // .itemo-color {

  // }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #2ec4b6;
}
.center {
  padding: 100px 0;
  margin-top: 20px;
  // background-color: #1c85f3;
  background-color: #3b9bff;
  // background: url();
  text-align: center;
  // min-width: 1200px;
}
.demo {
  text-align: center;
  margin: 20px;
}
.buttondemo {
  background-color: #2ec4b6;
  width: 120px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: #fdfffc;
}
.container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  // background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: FadeUp;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    // position: relative;
    // animation-name: FadeUp;
    // animation-duration: 1.5s;
    opacity: 0;
    text-align: center;
    margin-bottom: 30px;
    .title {
      font-size: 25px;
      color: #fff;
    }
    .text {
      color: #fff;
    }
  }
  .corner {
    // padding-top: 10px;
    margin: 15px auto;
    width: 0;
    height: 0;
    border: 10px solid #ff9f1c;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  &-item {
    // margin: 0px 5%;
    clear: both;
    width: 100%;
    // display: flex;
    // height: auto;
    padding: 40px 0 22px;
    margin-top: 60px;
    display: flow-root;
    .itemoer {
      transform: translateY(0%) !important;
      opacity: 1 !important;
      transition: all 1s ease;
      }
    .itemo {
      // position: relative;
      // animation-name: FadeDown;
      // animation-duration: 2s;
      // margin-top: 20px;
      // width: 350px;
      // height: 260px;
      // float: left;
      margin-top: 20px;
      position: relative;
      // transition: all 0.3s;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
      text-align: center;
      transform: translateY(-20%);
      opacity: 0;
      a {
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: none;
        background-color: #eee;
        // color: #333;
      }
      a:hover {
        border: 1px solid #26bbfb;
      }
      .itemo-color {
        background-color: #eee;
        width: 100%;
        height: 60%;
        margin: 0 auto;
        // height: 60%;
        // width: 120px;
        // height: 120px;
        // border-radius: 50%;
        position: relative;
        z-index: 2;
        // margin: 6% auto;
        overflow: hidden;
        // border: 2px solid #000000;
        img {
          // max-height:100%;
          // max-width:100%;
          height: 100%;
          width: inherit;
          // padding: 20% 2% 8% 2%;
        }
      }
      .one {
        width: 100%;
        height: 155px;
        background: rgba(116, 116, 156, 1.7);
        // background-size: cover;
        // background-position: center;
        padding-top: 45px;
        font-size: 24px;
        color: #011627;
        text-align: center;
        box-sizing: border-box;
      }
      .two {
        // font-size: 15px;
        // padding: 18px;
        // color: #011627;
        // height: 20%;
        font-size: 16px;
        // margin: 6% 0 0 0;
        padding: 15% 5% 40% 5%;
        color: #011627;
        height: 40%;
        background-color: lavender;
      }
      .button {
        font-size: 14px;
        // padding: 10px 0 10px 0;
        display: block;
        width: 105px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 15px;
        background: #26bbfb;
        margin: 0 auto;
        margin-top: 20px;
        // font-size: 13px;
        // margin-top: 30px;
        // background-color: lavender;
        // padding: 10px 0 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/center.vue